import React from 'react';
import Layout from '../components/Layout';
import HeroSection from './HeroSection';
import ProductGallerySection from './ProductGallerySection';
import TheJeetWaySection from './TheJeetWaySection.jsx';
import PartnerWithJeetarSection from './PartnerWithJeetarSection';
import DownloadAppSection from './DownloadAppSection';
import CovidResponseSection from './CovidResponseSection';
import WhereWeAreSection from './WhereWeAreSection';
import FaqSection from "../why-jeetar/FAQSection";

const IndexPage = ({ location }) => {
  return (
    <Layout location={location}>
      <HeroSection />
      <TheJeetWaySection />
      <WhereWeAreSection />
      {/* <PartnerWithJeetarSection /> */}
      <DownloadAppSection />
      <FaqSection />
      <CovidResponseSection />
    </Layout>
  );
};

export default IndexPage;
